import $ from "jquery";
import { View } from "backbone";
/* eslint-disable
    constructor-super,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-param-reassign,
    no-shadow,
    no-this-before-super,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let EditorialSidebarMenu;
export default EditorialSidebarMenu = class EditorialSidebarMenu extends View {
  initialize(options) {
    this._open = this._open.bind(this);
    this._toggle = this._toggle.bind(this);
    if (options == null) { options = {}; }
    this.editorialGrid = this.$el.find(".editorial-grid");
    this.editorialMenu = this.editorialGrid.find(".editorial-sidebar");
    this.editorialMenu.append("<a href='#' class='cover'></a>");
    this.editorialMenu.find("h3 a").on("click", this._open);
    this.editorialMenu.find(".cover").on("click", this._toggle);

    // the sidebar groups are hidden by default to give us a chance to initialize
    // the event listeners above, the menu doesn't work without them
    this.editorialMenu.find(".editorial-sidebar-group").show();
  }

  _open(event) {
    event.preventDefault();
    this.editorialGrid.addClass("editorial-sidebar-opened");
    const editorialGroup = $(event.currentTarget).parents(".editorial-sidebar-group");
    return editorialGroup.toggleClass("active");
  }

  _toggle(event) {
    event.preventDefault();
    this.$el.find(".editorial-sidebar-group").removeClass("active");
    return this.editorialGrid.toggleClass("editorial-sidebar-opened");
  }
};
